define([
    'edge/platform/featuredetection/ApplicationFeatures',
    'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/quickquote/pa/app'
], (ApplicationFeatures)=> {
    const lobModules = [];

    if (!ApplicationFeatures.hasFeature('role.vendor')) {
        if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
            lobModules.push('edge.quoteandbind.quickquote.pa.app');
        }
    }

    return lobModules;
});


/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/quickquote/SupportedLobModules.js
 **/